module.exports = __webpack_public_path__ + "img/yitihua.5122ffce.png";